

const initialState = {
    orderDeliveries: []
};


function OrderDeliveryReducer(state = initialState, action) {

    if (action.type === "ORDERDELIVERY_LIST") {
        var orderDeliveryDetails = {
            ...state,
            orderDeliveries: action.payload
        };
        return orderDeliveryDetails;
    }
    return state;
}

export default OrderDeliveryReducer;
